export default __webpack_public_path__ + "static/night_ctaModule_table_desktop-d8779b6e2572c13f0e96fc03381a8d43.png";